import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constant } from '../common/constant';
import { Observable } from 'rxjs';
import { AddPremiseHierarchyModel, AddPremiseData } from '../models/premise.model';

@Injectable()
export class PremiseService {

    constructor(private readonly http: HttpClient) {
    }

    addPremiseHierarchy(details): Observable<AddPremiseHierarchyModel> {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.CREATE_PREMISE_LEVEL;
        return this.http.post<AddPremiseHierarchyModel>(url , details);
    }

    getAllPremiseLevel(accountId)  {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.GET_ALL_PREMSIE_LEVEL + '?accountId=' + accountId;
        return this.http.get(url);
    }

    getUpperLevelList(accountId, levelId)  {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.GET_CHILD_BY_LEVEL_ID + '?accountId=' + accountId
        + '&levelId=' + levelId;
        return this.http.get(url);
    }

    registerPremiseData(details): Observable<AddPremiseData> {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.CREATE_PREMISE_HIERARCHY;
        return this.http.post<AddPremiseData>(url , details);
    }

    getAllPremiseDataByAccountId(params, accountId , levelId,  searchBy ) {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.GET_ALL_PREMSIE_DETAILS + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy
          + '&accountId=' + accountId + '&premiseHierarchyId=' + levelId;
        return this.http.get(url);
    }

    getPremiseDataById(id)  {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.GET_PREMISE_DETAILS_BY_ID + '?id=' + id;
        return this.http.get(url);
    }

    deletePremiseHierarchy(details): Observable<AddPremiseHierarchyModel> {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.DELETE_PREMISE_LEVEL;
        return this.http.post<AddPremiseHierarchyModel>(url , details);
    }

    deletePremiseById(id)  {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.DELETE_FLAT + '?flatId=' + id;
        return this.http.get(url);
    }

    getLastLevelHierarchy(accountId)  {
        const url = Constant.REST_URL + Constant.PREMISE + Constant.GET_ALL_FLAT_LIST + '?accountId=' + accountId+'&search=';
        return this.http.get(url);
    }
}
